<template>
  <div>
    <div class="row mt-5 b-form__row_type_flex-end">
      <div class="col-8">
        <label for="paymentKindName">
          {{$t('CONTENT.payments.payment_name_creation')}}:
        </label>
        <input
          data-cy="create-paymentKind-name"
          type="text"
          id="paymentKindName"
          class="b-input"
          name="paymentKindName"
          v-model="formData.name"/>
      </div>
    </div>
    <div class="row mt-5 b-form__row_type_flex-end">
      <div class="col-8">
        <div class="b-form__container">
          <label>{{$t('CONTENT.payments.payment_type_creation')}}:</label>
          <cool-select :list="paymentTypes"
                       option-value="codeName"
                       option-text="name"
                       v-model="paymentTypeCodeModel"
                       :placeholder="$t('CONTENT.choose')"
                       :isDisabled="isDisabledField"
          ></cool-select>
        </div>
      </div>
    </div>
    <div class="row mt-5 b-form__row_type_flex-end" v-if="isPaymentTypeHasKind">
      <div class="col-8">
        <checkbox class="b-checkbox" id="paymentKind" :disabled="isDisabledField" v-model="paymentKindModel">{{$t('CONTENT.payments.' + paymentKindCode)}}</checkbox>
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-6 offset-6">
        <div
          class="b-form__container b-form__container_type_flex b-form__container_type_flex_end"
        >
          <button
            data-cy="save-create-asset"
            class="b-btn b-btn_type_primary"
            type="button"
            @click="savePayment"
            :disabled="formData.name === undefined || formData.name === ''"
          >{{$t('CONTENT.save')}}
          </button>
          <button
            data-cy="cancel-create-asset"
            type="text"
            class="b-btn b-btn_type_empty m-2"
            @click.prevent="closeDialog"
          >{{$t('CONTENT.cancel')}}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
	import _ from "lodash";

	export default {
		props: {
			paymentForm: {
				type: Object,
				default: null,
			}
    },
		data() {
			return {
				formData: {},
				currentUnderlyingAssetTypeId: null,
        currentPaymentTypeCode: null,
				isPaymentTypeHasKind: false,
				paymentKindCode: null,
			}
		},
		created() {
			if(this.paymentForm !== null) {
				this.formData = _.cloneDeep(this.paymentForm);
        this.currentPaymentTypeCode = this.formData.paymentTypeCode;
				this.checkIsPaymentTypeHasKind();
				this.setPaymentKind();
			}
		},
    computed: {
			...mapGetters(["getPaymentTypes"]),
			...mapGetters(["paymentKindsAndTypes"]),
			isDisabledField() {
				if (this.paymentForm !== null) {
					return true;
        }
      },
      paymentTypeCodeModel: {
				get() {
          if(this.currentPaymentTypeCode) {
            return this.currentPaymentTypeCode;
          } else {
            return null;
          }
        },
        set(newVal) {
          this.currentPaymentTypeCode = newVal;
          this.checkIsPaymentTypeHasKind();
        }
      },
      paymentTypes() {
				return this.getPaymentTypes;
			},
			paymentKindModel: {
				get() {
					if (this.paymentForm !== null) {
						for (let i = 0; i < this.paymentKindsAndTypes.length; i++) {
							if (this.paymentKindsAndTypes[i].type === this.paymentForm.paymentTypeCode) {
								if (this.paymentKindsAndTypes[i].kind !== null && this.paymentKindsAndTypes[i].kind === this.formData.paymentKindCode) {
									return true;
								}
							}
						}
					} else {
						return false;
					}
        },
        set(val){
					if(val) {
						this.formData.paymentKindCode = this.paymentKindCode;
          } else {
						this.formData.paymentKindCode = null;
          }
        }
      },
    },
    methods: {
			setPaymentKind() {
				for (let i = 0; i < this.paymentKindsAndTypes.length; i++) {
          if (this.paymentKindsAndTypes[i].type === this.formData.paymentTypeCode) {
            if (this.paymentKindsAndTypes[i].kind !== null) {
              this.paymentKindCode = this.paymentKindsAndTypes[i].kind;
            }
          }
        }
      },
			checkIsPaymentTypeHasKind() {
				for (let i = 0; i < this.paymentKindsAndTypes.length; i++) {
					if (this.paymentKindsAndTypes[i].type === this.currentPaymentTypeCode) {
						this.isPaymentTypeHasKind = this.paymentKindsAndTypes[i].kind !== null;
						this.paymentKindCode = this.paymentKindsAndTypes[i].kind;
					}
				}
      },
			closeDialog() {
				this.$emit('closeDialog');
			},
			savePayment() {
        this.formData.paymentTypeCode = this.paymentTypeCodeModel;
				this.$emit('savePayment', this.formData);
      },
    }
	}
</script>
